export default __webpack_public_path__ + "static/media/twitter.5cbca2d1.svg";